const AUTH_TYPES = {
  RESET_STATE: "RESET_STATE",
  LOGIN_SUCCESS: "LOGIN_SUCCESS",
  LOGOUT: "LOGOUT",
  UPDATE_PROFILE: "UPDATE_PROFILE",
  ACCOUNT_CREATED:"ACCOUNT_CREATED",
  W9_FILLED:'W9_FILLED'
};

export default AUTH_TYPES;
